@if (hasProducts()) {
  @if (isKioskLayout()) {
    <section class="flex w-full flex-col gap-2.5">
      <h2
        class="kiosk-xl:text-3xl px-1 text-2xl font-semibold"
        [style.color]="textColor() | contentBuilderColor"
      >
        {{
          (title() | translateField: { defaultTranslationKey: 'promotion.title' }) || 'Nos Promos'
        }}
      </h2>
      <div
        class="grid gap-5"
        [style.gridTemplateColumns]="'repeat(' + productCardColumns() + ', minmax(0, 1fr))'"
      >
        @for (product of products(); track product.id) {
          <app-kiosk-product-card-factory
            [product]="product"
            [quantity]="product.quantity"
            [isProductAvailable]="isProductAvailable(product)"
            [textColor]="textColor()"
            [cardColor]="cardColor()"
            [buttonBackgroundColor]="buttonBackgroundColor()"
            [buttonTextColor]="buttonTextColor()"
            [priceColor]="priceColor()"
            (addProduct)="addProductDispatcher(product)"
            (showProduct)="openProductModal(product)"
          />
        }
      </div>
    </section>
  } @else {
    <section class="w-full">
      <div class="flex flex-col pt-2 lg:pt-4 pb-2 px-5 lg:px-12">
        <h2
          class="font-brand text-2xl lg:text-4xl font-bold"
          [style.color]="textColor() | contentBuilderColor: 'neutral-900'"
        >
          {{
            (title() | translateField: { defaultTranslationKey: 'promotion.title' }) || 'Nos Promos'
          }}
        </h2>
      </div>
      @if (tagColors$ | async; as tagColors) {
        <app-product-push-list-atom
          displayContext="promotion_block"
          [products]="products()"
          [tagColors]="tagColors"
          [productBackgroundColor]="productBackgroundColor()"
          [productNameColor]="productNameColor()"
          [productPriceColor]="productPriceColor()"
          (requestGoToProduct)="onProductClick($event)"
        />
      }
    </section>
  }
}
